import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import LoadingWrapper from 'components/Common/LoadingWrapper';
import ModalWrapper from 'components/Modals/ModalWrapper';
import { TextInput } from 'components/Common/Inputs/TextInput';

class EditFormReferenceModalForm extends Component {
  static defaultProps = {
    currentForm: [],
    isGettingFormReference: false
  };

  static propTypes = {
    isShown: PropTypes.bool.isRequired,
    onConfirmFormReferenceChange: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    isGettingFormReference: PropTypes.bool,
    currentForm: PropTypes.arrayOf(PropTypes.shape())
  };

  constructor(props) {
    super(props);
    this.state = {
      newFormRef: ''
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    const { onConfirmFormReferenceChange, currentForm } = this.props;
    const { newFormRef } = this.state;

    event.preventDefault();

    if (!newFormRef || newFormRef === null) {
      toastr.error('', 'Please, enter a new form reference or cancel the modal');
      return;
    }

    if (newFormRef.match(/[^A-Za-z\d_/.\\-]/)) {
      toastr.error('', 'No spaces or special characters allowed, please correct the form reference');
      return;
    }

    if (newFormRef && newFormRef.length > 150) {
      toastr.error('', 'Please, limit form reference to less than 150 characters');
      return;
    }

    onConfirmFormReferenceChange(currentForm[0].id, newFormRef);
    this.setState({ newFormRef: '' });
  }

  onFormReferenceChange = (e) => {
    this.setState({ newFormRef: e.target.value });
  };

  render() {
    const { isShown, onCancel, currentForm, isGettingFormReference } = this.props;

    return (
      <ModalWrapper
        headerClose={ false }
        isOpen={ isShown }
        title="Edit Form Metadata"
        btnConfirmTitle="Confirm"
        btnCancelTitle="Cancel"
        onCancel={ onCancel }
        formId="formReferenceEditForm"
        modalSize="edit-form-reference-modal"
        useDummySubmit
        disableConfirm={ () => !currentForm || currentForm.length > 1 }
      >
        <div className="edit-form-reference-modal">
          <form
            className="form-horizontal"
            id="formReferenceEditForm"
            name="formReferenceEditForm"
            onSubmit={ this.handleSubmit }
          >
            { currentForm && currentForm.length > 1 && <div className="form-group">
              <div className="col-12">
                <p>
                  Please select a single form to be able to edit the form reference.
                </p>
              </div>
            </div> }
            { currentForm && currentForm.length === 1 && <div>
              { isGettingFormReference && <LoadingWrapper loaded={ !isGettingFormReference } /> }
              { !isGettingFormReference && <div>
                <div className="form-group">
                  <div className="col-12 mt-2">
                    <p>
                      <b>Edit Form Reference</b>
                    </p>
                  </div>
                </div>
                <div className="form-group">
                  <div className="col-4">
                    <label
                      htmlFor="form-reference-id"
                      className="form-label m-2 text-right"
                    >
                      Form Reference
                    </label>
                  </div>
                  <div className="col-8">
                    <Field
                      id="form-reference-id"
                      name="formReference"
                      className="form-input"
                      component={ TextInput }
                      placeholder="Enter Reference..."
                      onChange={ e => this.onFormReferenceChange(e) }
                    />
                  </div>
                </div>
              </div> }
            </div> }
            <button
              type="submit"
              id="dummy-add-form-btn"
              className="none"
            >Confirm
            </button>
          </form>
        </div>
      </ModalWrapper>
    );
  }
}

const EditFormReferenceModalReduxForm = reduxForm({
  form: 'formReferenceEditForm'
})(EditFormReferenceModalForm);

function mapStateToProps(state) {
  const { forms: {
    isGettingFormReference,
    currentForm,
    formData
  } } = state;

  return {
    isGettingFormReference,
    currentForm,
    initialValues: !isGettingFormReference ? formData : null
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export const EditFormReferenceModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditFormReferenceModalReduxForm);

export default EditFormReferenceModal;
